<template>
  <div>
    <!-- Start Header Area -->
    <Header default-color="black">
      <img
          slot="logo"
          src="../../assets/images/layout/smile-logo.svg"
          class="logo-light"
          style="max-width: 13rem"
          alt="Smile Magazine Logo"
      />
      <img
          slot="logo-dark"
          src="../../assets/images/layout/smile-logo.svg"
          class="logo-dark"
          alt="Smile Magazine Logo"
      />
    </Header>
    <!-- End Header Area -->

    <!-- Start team Area  -->
    <div class="rn-team-area team-area rn-section-gap bg_color--1 mt-16">
      <v-container>
        <Team />
      </v-container>
    </div>
    <!-- End team Area  -->

    <!-- Start Footer Area  -->
    <Footer />
    <!-- End Footer Area  -->
  </div>
</template>
<script>
  import Header from "../layout/header/HeaderOnePage.vue"
  import Team from "../team/sections/Team.vue"
  import BannerTwo from "../../components/slider/BannerTwo";
  import Footer from "../../pages/layout/footer/Footer.vue";
  import Masonry from 'masonry-layout'
  export default {
    components: {
      Header,
      BannerTwo,
      Team,
      Footer,
    },
    data() {
      var grid = document.querySelector('.mesonry-list');
      var msnry = new Masonry( grid, {
        // options...
        itemSelector: '.masonry_item',
        columnWidth: 200,
        isAnimated: true
      });
      return {
        tab: null,
        index: null,
        tabItems: [],
        tabContent: [],
      };
    },
  };
</script>
